






























































































import { defineComponent, PropType } from '@nuxtjs/composition-api'
import LoanPerk from '~/components/car/classifieds/view/partials/loans/perks/LoanPerk.vue'
import { TbiLoanType } from '~/constants/loan/tbi'

export default defineComponent({
  props: {
    loanType: {
      type: String as PropType<TbiLoanType>,
      required: false,
      default: TbiLoanType.AUTO
    }
  },
  components: { LoanPerk },
  setup() {
    // const { isWithinTbiBlackFridayPeriod } = useBlackFriday()
    const isBlackFriday = false
    return {
      TbiLoanType,
      isBlackFriday
    }
  }
})
